import { siteInfo } from '@/mocks/homeMocks';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 64;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-800 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <a
                href="#hero"
                onClick={(e) => handleNavClick(e, '#hero')}
                className="flex items-center gap-2 mb-4 cursor-pointer"
              >
                <span className="text-xl text-primary-400">
                  <i className="ri-bug-line"></i>
                </span>
                <span className="font-heading text-lg text-foreground-100">
                  {siteInfo.name}
                </span>
              </a>
              <p className="text-xs leading-relaxed text-foreground-400 mb-4">
                虫虫漫画网是国内领先的免费漫画在线阅读平台，提供海量免费漫画、韩漫日漫国漫大全，支持全集漫画下拉式阅读，每日更新好看的漫画推荐。
              </p>
              <div className="flex items-center gap-3">
                <a href="#contact" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#contact" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#contact" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                  <i className="ri-mail-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-sm text-foreground-100 mb-4">快速导航</h3>
              <nav className="flex flex-col gap-2">
                {[
                  { label: '热门排行', href: '#ranking' },
                  { label: '精选推荐', href: '#cards' },
                  { label: '更新动态', href: '#updates' },
                  { label: '焦点专题', href: '#carousel' },
                  { label: '常见问题', href: '#faq' },
                ].map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
              </nav>
            </div>

            <div>
              <h3 className="text-sm text-foreground-100 mb-4">漫画分类</h3>
              <nav className="flex flex-wrap gap-2">
                {['热血少年', '恋爱甜宠', '悬疑推理', '奇幻冒险', '都市职场', '古风仙侠', '搞笑日常', '科幻未来', '校园青春', '治愈温馨'].map((cat) => (
                  <a
                    key={cat}
                    href="#topics"
                    className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat}
                  </a>
                ))}
              </nav>
            </div>

            <div>
              <h3 className="text-sm text-foreground-100 mb-4">合作伙伴</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                虫虫漫画网期待与更多优秀的漫画工作室、原创作者和行业伙伴携手合作，共同推动中国漫画文化的发展。
              </p>
            </div>
          </div>

          <div className="border-t border-background-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 {siteInfo.name} 版权所有 | 免费漫画免费看漫画网站
            </p>
            <div className="flex items-center gap-4">
              <a href="#faq" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">用户协议</a>
              <a href="#faq" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="#contact" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}